import {
  attachFormConfig,
  approvalInstanceStatus,
  approvalNodeStatus,
  approvalTaskStatus,
  coins,
  approvalNodeTypes,
  approvalInstanceType,
} from '@/const';
import { getApprovalInstanceDetail, getExpenseTypeList } from '@/api/approval'
import { getCompanyList } from '@/api/company'
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      instanceInfo: {}, // 实例基本信息
      nodeList: [],
      companysMap: {}
    }
  },
  computed: {
    instanceFormType() {
      if (this.instanceInfo.basic_info) {
        const mapItem =
          approvalInstanceType.constMap.idMap[
          this.instanceInfo.basic_info.type
          ];
        return mapItem.enName;
      } else {
        return '';
      }
    },
  },
  methods: {
    async initPage(id) {
      const companyRes = await getCompanyList({ page: 1, per_page: 10000, type: 1 });
      const expenseRes = await getExpenseTypeList({ page: 1, per_page: 20000 });
      const companysMap = {};
      let companys = [];
      if (
        companyRes.code === 0 &&
        companyRes.data &&
        Array.isArray(companyRes.data.items)
      ) {
        companys = companyRes.data.items;
      }
      if (
        expenseRes.code === 0 &&
        expenseRes.data &&
        Array.isArray(expenseRes.data.items)
      ) {
        this.expenseTypes = expenseRes.data.items;
      }
      companys.forEach((item) => {
        companysMap[item.id] = item;
      });
      this.companysMap = companysMap;
      const res = await getApprovalInstanceDetail(id);
      if (res.code != 0 || !res.data) throw new Error(res.message);
      this.instanceInfo = res.data;

      let isApprovaEnd = true;

      const nodeList = [];
      for (const item of res.data.node_list || []) {
        const nodeType = approvalNodeTypes.constMap.idMap[item.type];
        const nodeStatus = approvalNodeStatus.constMap.idMap[item.status];
        const elLineIcon = nodeStatus.elLineIcon;
        const elLineType = nodeStatus.elLineType;
        // if(instanceStatus != )isApprovaEnd

        if (!['APPROVED'].includes(nodeStatus.enName)) {
          isApprovaEnd = false;
        }
        /** 处理返回的attachForm数据，展示在页面上 */
        const instance_attr_info = item.instance_attr_info || {};
        const attachForm = [];
        let attachFormRole = 'readonlny'; // readonlny edit hidden
        let originalFormOperateRole = 'readonlny';
        const originalFormOperate =
          item.basic_node_info.properties.originalFormOperate || 1;
        try {
          if (['WAITING'].includes(nodeStatus.enName)) throw new Error('未审批节点不展示');
          const attachFormOrigin =
            item.basic_node_info.properties.attachForm || [];
          for (const attachItem of attachFormOrigin) {
            try {
              let attachItemNew = _.cloneDeep(
                attachFormConfig.constMap.idMap[attachItem.name]
              );
              if (nodeStatus.enName != 'PENDING') {
                attachItemNew.disabled = true;
                originalFormOperateRole = 'readonlny';
                attachFormRole = 'readonlny';
              }
              if (attachItemNew.formType === 'select') {
                attachItemNew.options =
                  // eslint-disable-next-line no-await-in-loop
                  (await attachItemNew.opetionGenerator()) || [];
              }

              attachItemNew.value =
                instance_attr_info[attachItemNew.field] ||
                attachItemNew.value;
              if (
                !attachItemNew.value &&
                attachItemNew.formType === 'datetime'
              ) {
                attachItemNew.value = dayjs().format('YYYY-MM-DD HH:mm:ss');
              }
              attachForm.push(attachItemNew);
            } catch (err) {
              /** */
            }
          }
        } catch (err) {
          /** */
        }
        // 修改记录是否显示 需要放在下面处理task_list数据前，使用后端返回的第一手数据
        if (item.task_list && item.task_list.length > 0) {
          item.modify_log_show = item.task_list.some((taskItem) => {
            return !!taskItem.modify_log;
          });
        } else {
          item.modify_log_show = false;
        }

        // 设置允许拒绝按钮审批权限(审批中)
        // if (
        //   nodeStatus.enName == 'PENDING' &&
        //   Array.isArray(item.task_list)
        // ) {
        //   item.task_list.forEach((taskItem) => {
        //     // zhangbo 1.任务中有用户id等于登录的id时，说明你有编辑权限，
        //     if (taskItem.user_open_id != this.my_user_open_id) return;
        //     attachFormRole = 'edit';
        //     originalFormOperateRole = 'edit';
        //     // 2.任务状态为该你审批中时，则显示操作按钮
        //     const taskStatus =
        //       approvalTaskStatus.constMap.idMap[taskItem.status];
        //     if (taskStatus.enName === 'PENDING') {
        //       this.actions.allow = true;
        //       this.actions.deny = true;
        //       this.actions.taskId = taskItem.id;
        //     }
        //   });
        // }

        if (
          nodeStatus.enName == 'WAITING' &&
          Array.isArray(item.approver)
        ) {
          const task_list = item.approver.map((approverItem, index) => {
            return {
              username: approverItem.username,
              user_open_id: approverItem.user_open_id,
              status: 0,
              id: 'abc' + index,
            };
          });
          if (Array.isArray(item.task_list) && item.task_list.length <= 0) item.task_list = task_list;
        }
        if (nodeType.enName === 'start') {
          const task_list = [
            {
              username: this.instanceInfo.promoter,
              status: item.status,
              id: 'aaaa',
              end_time: item.end_time,
            },
          ];
          item.task_list = task_list;
        }

        const res = {
          elLineIcon,
          elLineType,
          attachForm,
          attachFormRole,
          originalFormOperate,
          originalFormOperateRole,
          ...item,
        };

        nodeList.push(res);
      }

      const endNodeStatus = approvalNodeStatus.constMap.idMap[isApprovaEnd ? '2' : '0'];
      nodeList.push({
        elLineIcon: endNodeStatus.elLineIcon,
        elLineType: endNodeStatus.elLineType,
        type: 0, // end
      });
      this.nodeList = nodeList;
    },
    async initSpendMoney(id) {
      try {
        const res = await getApprovalInstanceDetail(id);
        if (res.code != 0 || !res.data) throw new Error(res.message);
        this.instanceInfo = res.data;
      } catch (err) {
        this.$message.error(err.response && err.response.data ? err.response.data.message : err.message)
      }
    },
    // 公共数据
    handleCommon() {
      const { basic_info } = this.instanceInfo;
      let base = [
        {
          title: '发起人',
          content: this.instanceInfo.promoter,
        },
        {
          title: '审批类型',
          content: basic_info.name,
        },
        {
          title: '发起时间',
          content: this.instanceInfo.start_time,
        },
        {
          title: '结束时间',
          content: this.instanceInfo.end_time || '--/--',
        },
        {
          title: '审批状态',
          content:
            approvalInstanceStatus.constMap.idMap[this.instanceInfo.status]
              .name,
        },
        {
          title: '审批类型',
          content: basic_info.name,
        },
      ];
      let approve = [];
      for (let i = 0; i < this.nodeList.length; i++) {
        let task_node = {
          id: this.nodeList[i].id,
          task_list: [],
        };
        if (!this.nodeList[i].task_list) continue;
        this.nodeList[i].task_list.forEach((task) => {
          task_node.task_list.push({
            id: task.id,
            username: task.username,
            status: approvalTaskStatus.constMap.idMap[task.status].name,
            end_time: task.end_time,
          });
        });
        approve.push(task_node);
      }
      return { base, approve };
    },
    // 1.报销
    handleReimbursement(form) {
      let applayReimbursement = [
        {
          name: '报销标题',
          content: form.title,
        },
        {
          name: '报销人',
          content: form.real_user_info.name,
        },
        {
          name: '公司主体',
          content: this.companysMap[form.owner_company_id].name || '--/--',
        },
        {
          name: '项目名称',
          content: form.owner_project_info.name,
        },
        {
          name: '总金额',
          content: form.sum_money,
        },
        {
          name: '币种类型',
          content: coins.constMap.idMap[form.coin_type].name || '--/--',
        },
      ];
      let expenseTypesMap = {};
      this.expenseTypes.forEach((item) => {
        expenseTypesMap[item.id] = item;
      });
      let applayReimbursementTable1 = form.detail.map((item) => {
        return {
          name: expenseTypesMap[item.type]
            ? expenseTypesMap[item.type].name
            : '--/--',
          money: item.money,
          sum_tax_amount: item.sum_tax_amount || '-/-',
          created_at: item.created_at,
          error_msg: item.error_msg || '-/-',
          remark: item.remark,
        };
      });
      // 表单2
      let list = this.expenseTypes.map((item) => {
        return {
          id: item.id,
          name: item.name,
          money: 0,
        };
      });

      form.detail.forEach((item) => {
        list.forEach((typeItem) => {
          if (item.type == typeItem.id) {
            typeItem.money += item.money;
          }
        });
      });
      let applayReimbursementTable2 = list.filter((item) => {
        return item.money != 0;
      });


      let printFileData = {
        applayReimbursement,
        applayReimbursementTable1,
        applayReimbursementTable2,
      };
      return printFileData;
    },
    // 2用款申请
    handleApplySpendMoney(form) {
      let applySpendMoney = [
        {
          title: '用款事由',
          content: form.title,
        },
        {
          // 提出来
          title: '费用部门',
          content: form.department_info ? form.department_info.name : '-/-',
        },
        {
          title: '我方公司',
          content: form.owner_company_info
            ? form.owner_company_info.name
            : '--/--',
        },
        {
          title: '对方公司',
          content: form.other_company_info
            ? form.other_company_info.name
            : '--/--',
        },
        {
          title: '对方银行',
          content: form.other_bank_info ? form.other_bank_info.name : '--/--',
        },
        {
          title: '对方开户行',
          content: form.other_bank_info
            ? form.other_bank_info.address
            : '--/--',
        },
        {
          title: '对方银行账号：',
          content: form.other_bank_info ? form.other_bank_info.number : '--/--',
        },
        {
          title: '最晚付款日期：',
          content: form.last_pay_time || '--/--',
        },
        {
          title: '币种类型',
          content: coins.constMap.idMap[form.coin_type].name || '--/--',
        },
        {
          title: '总金额',
          content: form.sum_money,
        },
        {
          title: '备注信息',
          content: form.remark,
        },
      ];
      return { applySpendMoney };
    },
    // 3.备用金
    handleApplayReserveFunds(form) {
      let applayReserveFunds = [
        {
          title: '申请事由',
          content: form.title,
        },
        {
          title: '收款人',
          content: form.receive_name || '--/--',
        },
        {
          title: '开户行',
          content: form.receive_bank_type || '--/--',
        },
        {
          title: '收款账号',
          content: form.receive_bank_no || '--/--',
        },
        {
          title: '最晚归还',
          content: form.back_time || '--/--',
        },
        {
          title: '币种类型',
          content: coins.constMap.idMap[form.coin_type].name || '--/--',
        },
        {
          title: '总金额',
          content: form.sum_money,
        },
      ];

      return { applayReserveFunds };
    },
    // 7确认费用
    handleConfirmCost(form) {
      let confirmCost = [
        {
          title: '费用事由',
          content: form.title,
        },
        {
          title: '我方公司',
          content: form.owner_company_info
            ? form.owner_company_info.name
            : '--/--',
        },
        {
          title: '对方公司',
          content: form.other_company_info
            ? form.other_company_info.name
            : '--/--',
        },
        {
          title: '入账时间',
          content: form.entry_pay_time ? form.entry_pay_time : '--/--',
        },
        {
          title: '税前金额',
          content: form.sum_money || '--/--',
        },
        {
          title: '进账税额',
          content: form.income_tax_money || '--/--',
        },
        {
          title: '币种类型',
          content: coins.constMap.idMap[form.coin_type].name || '--/--',
        },
        {
          title: '备注信息',
          content: form.remark,
        },
      ];
      return { confirmCost };
    },

    dealSpendMoneyData() {
      const { form } = this.instanceInfo;
      let printFileData = {
        department: this.instanceInfo.user_info.department.name,
        created_at: this.instanceInfo.created_at,
        other_company: form.other_company_info.name,
        other_company_bank: form.other_bank_info.name,
        other_company_number: form.other_bank_info.number,
        content: form.title,
        money: form.sum_money,
        coin_type: form.coin_type,
        coin_name: coins.constMap.idMap[form.coin_type].name,
        coin_Enname: coins.constMap.idMap[form.coin_type].EnName,
      };
      sessionStorage.setItem(
        'ag-print-spend-money',
        JSON.stringify(printFileData)
      );
    }
  },

}
